import api from "../api";

export default {
    create(data) {
        return api.post(`/commerce/orders`, data);
    },

    update(order, data, signature) {
        return api.patch(`/commerce/orders/${order}`, data, { params: { signature } })
    },

    place(order, data, signature) {
        return api.post(`/commerce/orders/${order}/place`, data, { params: { signature } })
    }
};
